import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './TableRow.scss';

class TableRow extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func
  };

  render() {
    const { children, className, onClick } = this.props;
    const classComponent = classNames('table-row', className, {
      clickable: onClick
    });

    return (
      <div role="row" className={classComponent} onClick={onClick}>
        {children}
      </div>
    );
  }
}

export default TableRow;
